import { createRouteNode } from '@owlsdepartment/vue-tree-routes';

import { Subject } from '@/common/abilities';
import LayoutAdmin from '@/layouts/LayoutAdmin.vue';

const ViewAdminMaterials = () => import('@/views/admin/materials/ViewAdminMaterials.vue');

export default createRouteNode({
	shared: {
		basePath: '/materials',
		meta: {
			abilitySubject: Subject.ADMIN_PANEL,
			layout: {
				component: LayoutAdmin,
			},
		},
	},

	routes: [
		{
			name: 'admin-materials',
			path: '/',
			component: ViewAdminMaterials,
		},
	],
});
